import React from "react";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { appBarStyles } from "./appBarTheme";

const styles = (theme: Theme) => createStyles(appBarStyles(theme));

interface Props {
  classes: { logoLink: string; logoText: string };
}

const AppBarLogo = ({ classes }: Props) => (
  <Link to="/" className={classes.logoLink}>
    <Typography component="span" className={classes.logoText} color="inherit">
      Labeler
    </Typography>
  </Link>
);

export default withStyles(styles)(AppBarLogo);
